import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import { bootI18n } from "@/i18n/boot";

// App modules are imported only after live translation overrides are applied,
// so data localised at module load (L()) already reflects team edits.
bootI18n().then(() => import("@/App")).then(({ default: App }) => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
